//******************************************************************************
// プロトコルpcpng
// 空のcanvasを返すためのプロトコル
//******************************************************************************

//------------------------------------------------------------------------------
// 共通利用するcanvas
const canvas = document.createElement("canvas");
canvas.width = 256;
canvas.height = 256;

//------------------------------------------------------------------------------
// プロトコル関数
const pcpngTileEmptyCanvas = async (params, abortController) => {
	//----------------------------------------------------------------------
	return await new Promise((resolve) => {
		canvas.toBlob(async (blob) => {
			const arraybuffer = await blob.arrayBuffer();
			resolve({ data: arraybuffer });
		});
	});
};

//------------------------------------------------------------------------------
// export
export default pcpngTileEmptyCanvas;
